(() => {
  const cfg = window.aptsValidate || {};
  const msg = {
    required: cfg.required || 'This field is required.',
    email: cfg.email || 'Please enter a valid email address.',
    emailRequired: cfg.emailRequired || 'Please enter your email address.',
    invalid: cfg.invalid || 'Please check this field.'
  };
  const skip = (form) => form.matches('[data-apts-novalidate], .cart-form');
  const fields = (form) => [...form.elements].filter((el) => el.willValidate && !el.disabled && el.type !== 'hidden' && el.type !== 'submit');

  const messageFor = (el) => {
    const v = el.validity;
    if (v.valueMissing) return el.type === 'email' ? msg.emailRequired : el.dataset.aptsRequired || msg.required;
    if (v.typeMismatch && el.type === 'email') return msg.email;
    return el.dataset.aptsInvalid || msg.invalid;
  };

  const holder = (el) => el.closest('.field, .email-signup__input-group, .newsletter-form__field-wrapper, .form-field, label') || el;

  const clear = (el) => {
    el.classList.remove('apts-invalid');
    el.removeAttribute('aria-invalid');
    const id = el.dataset.aptsErr;
    if (id) document.getElementById(id)?.remove();
    delete el.dataset.aptsErr;
  };

  const show = (el) => {
    clear(el);
    const id = `apts-err-${Math.random().toString(36).slice(2, 9)}`;
    const p = document.createElement('p');
    p.className = 'apts-field-error';
    p.id = id;
    p.setAttribute('role', 'alert');
    p.textContent = messageFor(el);
    el.classList.add('apts-invalid');
    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', id);
    el.dataset.aptsErr = id;
    let anchor = holder(el);
    while (anchor.parentElement && anchor.parentElement !== el.form?.parentElement) {
      const cs = getComputedStyle(anchor.parentElement);
      const row = (cs.display.includes('flex') && !cs.flexDirection.startsWith('column') && cs.flexWrap === 'nowrap') || cs.display.includes('grid');
      if (!row) break;
      anchor = anchor.parentElement;
    }
    anchor.insertAdjacentElement('afterend', p);
  };

  const prep = (form) => {
    if (form.dataset.aptsValidate || skip(form)) return;
    form.dataset.aptsValidate = '1';
    form.noValidate = true;
    fields(form).forEach((el) => el.removeAttribute('title'));
  };

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || skip(form)) return;
    prep(form);
    const bad = fields(form).filter((el) => !el.checkValidity());
    fields(form).forEach(clear);
    if (!bad.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    bad.forEach(show);
    bad[0].focus();
  }, true);

  document.addEventListener('input', (e) => {
    const el = e.target;
    if (el.classList && el.classList.contains('apts-invalid') && el.checkValidity()) clear(el);
  });

  document.addEventListener('invalid', (e) => {
    const form = e.target.form;
    if (form && !skip(form)) e.preventDefault();
  }, true);

  const scan = () => document.querySelectorAll('form').forEach(prep);
  scan();
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(scan, 200); }).observe(document.documentElement, { childList: true, subtree: true });
})();
